type RGBTypes = {
  [key: string]: [number, number, number]
}

type RGBKey = keyof RGBTypes

type ColorOptionTypes = {
  name: string
  rgb: RGBTypes
}

type ColorOptionArrTypes = ColorOptionTypes[]

const colorArr: ColorOptionArrTypes = [
  {
    name: "blue",
    rgb: {
      base: [0, 106, 171],
      xdk: [1, 70, 112],
    },
  },
  {
    name: "grey",
    rgb: {
      base: [155, 160, 162],
      xlt: [225, 225, 225],
      dk: [34, 39, 61],
    },
  },
  {
    name: "green",
    rgb: {
      base: [118, 166, 97],
      hlt: [96, 197, 52],
      lnk: [0, 123, 40],
      lnkhlt: [0, 195, 63],
      lnklt: [58, 191, 0], // 0, 195, 63
      lnklthlt: [69, 226, 1],
      dk: [11, 64, 28],
      dkhlt: [0, 107, 34],
    },
  },
  {
    name: "purple",
    rgb: {
      base: [153, 125, 159],
    },
  },
  {
    name: "red",
    rgb: {
      base: [187, 51, 55],
      hlt: [224, 37, 42],
    },
  },
]

const rgbaToHex = (r, g, b, a) => {
  const outParts = [
    r.toString(16),
    g.toString(16),
    b.toString(16),
    Math.round(a * 255)
      .toString(16)
      .substring(0, 2),
  ]

  // Pad single-digit output values
  outParts.forEach((part, i) => {
    if (part.length === 1) {
      outParts[i] = "0" + part
    }
  })

  return outParts.join("")
}

export default (
  color: string,
  variant?: RGBKey,
  opacity?: number,
  cloudinary?: boolean
) => {
  const clrObj = colorArr.filter(clr => clr.name === color)[0]
  const variantArr = variant ? clrObj.rgb[variant] : clrObj.rgb["base"]

  const opacityVal = opacity ? opacity : 1

  const rgbaString = rgbaToHex(
    variantArr[0],
    variantArr[1],
    variantArr[2],
    opacityVal
  )

  return cloudinary ? rgbaString : `rgba(${variantArr}, ${opacityVal})`
}
